import { render, staticRenderFns } from "./showKnowledge.vue?vue&type=template&id=1c4df098&scoped=true"
import script from "./showKnowledge.vue?vue&type=script&lang=js"
export * from "./showKnowledge.vue?vue&type=script&lang=js"
import style0 from "./showKnowledge.vue?vue&type=style&index=0&id=1c4df098&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4df098",
  null
  
)

export default component.exports